import { HeaderPanel } from "../../HeaderPanel";
import React from "react";
import { headerPanelOptions } from "./panelSettings";
import './Preview.less'

interface PreviewPanelProps {
  previewUrl: string;
}

const detailsPreviewClass = `dp-entitydetails-preview`;

export function PreviewPanel({ previewUrl }: PreviewPanelProps) {
  return (
    <HeaderPanel {...headerPanelOptions('primary', 'Preview')}>
      <div className={detailsPreviewClass}>
        <img alt="Entity Preview" className={`${detailsPreviewClass}__image`} src={`${previewUrl}`} />
      </div>
    </HeaderPanel>
  );
}
